{
  "强化学习：在试错里变强 · 物理AI实验室 Lab 1.7": {
    "en": "Reinforcement learning: getting better by trial and error · Physical AI Lab 1.7",
    "ja": "強化学習：試行錯誤で強くなる · Physical AI Lab 1.7"
  },
  "在试错里变强": {
    "en": "Better by trial and error",
    "ja": "試行錯誤で強くなる"
  },
  "没有示范，只有奖励。机械臂一轮轮试，按得分改自己，从乱挥到够到杯子。奖励写歪一点，它就钻空子。": {
    "en": "No demos, just a reward. Try, score, adjust: from flailing to reaching the cup. Skew the reward and it games it.",
    "ja": "デモはなく報酬だけ。試しては得点で自分を直し、でたらめな動きからカップに届くまでに。報酬が少しずれると、抜け道を突く。"
  },
  "训练曲线 · 每一轮都在同样 100 个杯子位置上评测": {
    "en": "Training curves · scored on 100 fixed cups",
    "ja": "学習曲線 · 毎回同じ 100 のカップ位置で評価"
  },
  "平均回报（一局的总得分）": {
    "en": "Mean return (total score of an episode)",
    "ja": "平均リターン（1エピソードの合計得点）"
  },
  "任务真的做成了（手停在杯子旁，杯子没被推开）": {
    "en": "Task actually done (hand stops by the cup, cup not pushed away)",
    "ja": "本当に達成（手がカップの横で止まり、カップは押されていない）"
  },
  "奖励：够到杯子": {
    "en": "Reward: reach",
    "ja": "報酬：届く"
  },
  "奖励：只要杯子动了": {
    "en": "Reward: the cup just moves",
    "ja": "報酬：カップが動けばいい"
  },
  "奖励：杯子动了": {
    "en": "Reward: moved",
    "ja": "報酬：動いた"
  },
  "这一只 · policy": {
    "en": "This policy",
    "ja": "この方策 · policy"
  },
  "训练进度": {
    "en": "Training",
    "ja": "学習の進み"
  },
  "探索强度": {
    "en": "Exploration",
    "ja": "探索の強さ"
  },
  "拖训练进度 · 切奖励 · 把探索调大看早期乱试 · 拖动空白处旋转视角": {
    "en": "Drag training progress · switch the reward · turn exploration up to see early flailing · drag empty space to orbit",
    "ja": "学習の進みをドラッグ · 報酬を切り替え · 探索を強めて初期の試行を見る · 空いた所をドラッグして視点を回す"
  },
  "第 {0} 轮": {
    "en": "#{0}",
    "ja": "第 {0} 回"
  },
  "训练 {0} / {1} · 探索噪声 σ {2}": {
    "en": "Training {0} / {1} · noise σ {2}",
    "ja": "学習 {0} / {1} · 探索ノイズ σ {2}"
  },
  "（按评测方式：不加噪声）": {
    "en": " (eval: no noise)",
    "ja": "（評価と同じく：ノイズなし）"
  },
  "这一轮评测：平均回报 {0} · 做成 {1}": {
    "en": "Eval: return {0} · done {1}",
    "ja": "評価：平均リターン {0} · 達成 {1}"
  },
  "这一局：第 {0} s · 得分 {1}": {
    "en": "This episode: {0} s · score {1}",
    "ja": "このエピソード：{0} s · 得点 {1}"
  },
  "奖励：<code>− 离杯子的距离 − 推动杯子 + 停在杯子旁</code>": {
    "en": "Reward: <code>− distance to cup − pushing the cup + resting by the cup</code>",
    "ja": "報酬：<code>− カップまでの距離 − カップを押す + カップの横で止まる</code>"
  },
  "奖励：<code>+ 杯子移动的距离</code>，别的都不管": {
    "en": "Reward: <code>+ distance the cup moved</code>, nothing else",
    "ja": "報酬：<code>+ カップが動いた距離</code>、他は一切見ない"
  },
  "! 钻空子": {
    "en": "! GAMING IT",
    "ja": "! 抜け道"
  },
  "把杯子扫飞，分数照涨，任务没做成": {
    "en": "knocks the cup away, the score still climbs, the task isn't done",
    "ja": "カップを払い飛ばす。得点は伸びるが、タスクは未達成"
  },
  "✓ 够到了": {
    "en": "✓ REACHED",
    "ja": "✓ 届いた"
  },
  "停在杯子旁，杯子没被推开": {
    "en": "stops by the cup, cup not pushed away",
    "ja": "カップの横で止まり、カップは押されていない"
  },
  "! 把杯子推开了": {
    "en": "! PUSHED THE CUP",
    "ja": "! カップを押しのけた"
  },
  "! 没够到": {
    "en": "! MISSED",
    "ja": "! 届かなかった"
  },
  "这一局没做成": {
    "en": "this episode failed",
    "ja": "このエピソードは未達成"
  },
  "▸ 乱试": {
    "en": "▸ FLAILING",
    "ja": "▸ でたらめ"
  },
  "还没学会，动作几乎是随机的": {
    "en": "not learned yet, actions nearly random",
    "ja": "まだ学んでおらず、動きはほぼランダム"
  },
  "▸ 伸手中": {
    "en": "▸ REACHING",
    "ja": "▸ 手を伸ばし中"
  },
  "按学到的策略出动作": {
    "en": "acting on the learned policy",
    "ja": "学んだ方策で動作"
  },
  "PPO · {0} 个并行环境 × {1} 轮 · 策略 {2} · 本页在浏览器里重放保存下来的 12 个检查点（train.py，torch {3}）": {
    "en": "PPO · {0} parallel envs × {1} iterations · policy {2} · replays the 12 saved checkpoints in the browser (train.py, torch {3})",
    "ja": "PPO · 並列環境 {0} × {1} 回 · 方策 {2} · このページは保存した 12 個のチェックポイントをブラウザで再生（train.py、torch {3}）"
  }
}
